import { SchemasService } from '../services/schemas.service';
import { DocumentService } from '../services/document.service';
import { BPMService } from '../services/bpm.service';
import moment from 'moment';
import { BPM_DECISION_PROPERTY_NAME, BLOCK_FILES_REQUIRED, BLOCK_ANSWER_DATA, BLOCK_RES_FILES } from '../config/consts';
import { parseFunctionsFromSchema } from "@/utility/routines";

// initial state
const state = {
    requestLoading: false,
    requestFolderId: '',
    requestData: {},
    requestSchema: [],
    needSign: false,
    hideDraftBtn: false,
    signInfo: {},
    processData: {
        processDocumentFolderID: '',
        processName: '',
        processId: '',
        processStartTaskId: ''
    },
    requestList: {}
};

// getters
const getters = {
    requestTableDataContent(state) {
        let content = [];
        for (var i in state.requestList.content) {
            state.requestList.content[i].data.mainData.id = state.requestList.content[i].id;
            content[i] = state.requestList.content[i].data.mainData;
            content[i].roesName = state.requestList.content[i].data.accountsData.roes_name;
            content[i].accountNumber = state.requestList.content[i].data.accountsData.account_number;
        }
        return content;
    },
    processDocumentFolderID(state) {
        return state.processData.processDocumentFolderID;
    },
    processName(state) {
        return state.processData.processName;
    },
    processId(state) {
        return state.processData.processId;
    },
    processStartTaskId(state) {
        return state.processData.processStartTaskId;
    },
    requestProcessId(state) {
        return state.requestData.requestProcessId ? state.requestData.requestProcessId : undefined;
    },
    visibleRequestSchema(state) {
        return state.requestSchema.filter(item => {
            // по умолчанию блок имеет visible = true
            // прячем блоки с visible = false
            if (item.hasOwnProperty('visible') && typeof item.visible === 'boolean') {
                return item.visible;
            } else {
                return true;
            }
        });
    }
};

// actions
const actions = {
    async getDocumentSignInfo({ commit }, documentId) {
        commit('setSignInfo', {});
        let res = await DocumentService.getDocumentEDS(documentId);
        commit('setSignInfo', res);
    },
    async swithRequestLoading({ commit }, value) {
        commit('setRequestLoading', value);
    },
    async downloadFile(store, fileId) {
        return await DocumentService.downloadFile(fileId);
    },
    async getAcceptDocuments() {

        const [docRu, docKaz] = await Promise.all([
            await DocumentService.acceptRequestDoc('rus', state.requestData),
            await DocumentService.acceptRequestDoc('kaz', state.requestData),
        ]);
        const docRuParsed = {name: docRu.name, id: docRu.id};
        const docKazParsed = {name: docKaz.name, id: docKaz.id};

        if(!state.requestData.hasOwnProperty('requestFiles')){
            state.requestData.requestFiles = {};
        }

        state.requestData.requestFiles.AcceptRus = [docRuParsed];
        state.requestData.requestFiles.AcceptKaz = [docKazParsed];


        // await DocumentService.acceptRequestDoc('kaz', state.requestData),

    },
    async uploadRequiredFiles({ commit }, requestData) {
        let requiredFilesBlock = {};
        if (requestData[BLOCK_FILES_REQUIRED]) {
            try {
                await Promise.all(
                    Object.keys(requestData[BLOCK_FILES_REQUIRED]).map(async key => {
                        requiredFilesBlock[key] = [];
                        await Promise.all(
                            requestData[BLOCK_FILES_REQUIRED][key].map(async file => {
                                if (!file.id) {
                                    file.id = await DocumentService.uploadFile(file.data, file.name);
                                }
                                requiredFilesBlock[key].push({
                                    id: file.id,
                                    name: file.name
                                });
                            })
                        );
                    })
                );

                requestData[BLOCK_FILES_REQUIRED] = requiredFilesBlock;
            } catch (error) {
                console.log(error);
                return false;
            }
        }
        return true;
    },
    async uploadOtherFiles({ commit }, requestData) {
        try {
            const otherFilesBlocks = [{ parent: BLOCK_ANSWER_DATA, child: BLOCK_RES_FILES }]; //блоки где есть файлы для загрузки, которые не в BLOCK_FILES_REQUIRED
            await Promise.all(
                otherFilesBlocks.map(async block => {
                    if (requestData[block.parent] && requestData[block.parent][block.child]) {
                        await Promise.all(
                            requestData[block.parent][block.child].map(async (file, i) => {
                                if (!file.id) {
                                    file.id = await DocumentService.uploadFile(file.data, file.name);
                                    requestData[block.parent][block.child][i] = {
                                        id: file.id,
                                        name: file.name
                                    };
                                }
                            })
                        );
                    }
                })
            );
        } catch (e) {
            console.log(e);
            return false;
        }
        return true;
    },
    async getRequestList({ commit }, { folderId, status, requestType, roesName, dateFrom, dateTo, p }) {
        try {
            commit('setRequestLoading', true);
            commit('setRequestList', {});
            let requestList = await DocumentService.getDocumentsTableAll(
                folderId,
                status,
                requestType,
                roesName,
                dateFrom,
                dateTo,
                p.page - 1,
                p.rowsPerPage == -1 ? p.totalItems : p.rowsPerPage,
                p.sortBy,
                p.descending
            );
            commit('setRequestList', requestList);
        } catch (e) {
            console.log('request.getRequestList error: ' + e);
        } finally {
            commit('setRequestLoading', false);
        }
    },
    async clearRequest({ commit }) {
        commit('setRequestSchema', []);
        commit('setRequestData', {});
        commit('setProcessData', {
            processDocumentFolderID: '',
            processName: '',
            processId: '',
            processStartTaskId: ''
        });
    },
    async createNewRequest({ commit, dispatch }, { processDocumentFolderID, userData }) {
        try {
            commit('setNeedSign', false);
            commit('setHideDraftBtn', false);
            commit('setRequestLoading', true);
            let processFolderData = await DocumentService.getDocumentFoldersById(processDocumentFolderID);
            let processName = processFolderData.data.name___Ru ? processFolderData.data.name___Ru : processFolderData.data.name;
            let processId = processFolderData.data.processId;
            let processStartTaskId = processFolderData.data.processStartTaskId;
            let processSchemaTaskData = await BPMService.getProcessesSchemaTask(processId, processStartTaskId);

            let schemaData = await SchemasService.getSchemaById(processSchemaTaskData.schemaId);
            commit('setNeedSign', schemaData.data.needSign);
            commit('setHideDraftBtn', schemaData.data.hideDraftBtn);
            await Promise.all(
                // параллелим запросы схем черех .map
                schemaData.data.data.map(async item => {
                    let r = await SchemasService.getSchemaById(item.schemaId);
                    item.schema = await r.data.schema;
                })
            );
            // создаём начальный объект со структурой заявки соответсвующей загруженной схеме
            let dataBlock = {};
            schemaData.data.data.forEach(schemaBlock => {
                dataBlock[schemaBlock.code] = {};
            });
            dataBlock.mainData = {
                requestProcessId: undefined,
                requestNumber: undefined,
                author: userData.userFullName,
                createDateTime: undefined,
                signedDateTime: undefined,
                status: undefined
            };
            // В заявке "АКЦЕПТ" контактные данные отсутсвуют, а он по дефолту требуется
            if (!dataBlock.hasOwnProperty('contactsData')) {
                dataBlock.contactsData = {};
            }
            dataBlock.contactsData.email = userData.userEmail;
            dispatch('parseSchemas', schemaData.data.data);
            // commit('setRequestSchema', schemaData.data.data);
            commit('setRequestData', dataBlock);
            commit('setProcessData', {
                processDocumentFolderID: processDocumentFolderID,
                processName: processName,
                processId: processId,
                processStartTaskId: processStartTaskId
            });
            return true;
        } catch (e) {
            console.log('request.createNewRequest error: ' + e);
            return false;
        } finally {
            commit('setRequestLoading', false);
        }
    },
    /**
     * Сохраняет новую заявку.
     */
    async saveNewRequest({ getters }, { requestData, folderId }) {
        try {
            let fullData = { folderId: folderId, data: requestData };

            // запускаем процесс
            let requestProcessId = await BPMService.postStartNewProcess(getters.processId, getters.processStartTaskId);
            // TODO: Временный хард-код
            fullData.data.mainData.requestProcessId = requestProcessId;
            fullData.data.mainData.createDateTime = moment().format();
            fullData.data.mainData.status = 'Черновик';
            let documentData = await DocumentService.postDocuments(fullData);
            return {
                processId: requestProcessId,
                documentId: documentData.id
            };
        } catch (e) {
            // TODO: отмена запущеного процесса
            console.log('request.saveRequest error: ' + e);
            return null;
        } finally {
        }
    },
    async saveDraft({ getters }, { requestData, folderId }) {
        try {
            let fullData = { folderId: folderId, data: requestData };
            // запускаем процесс
            let requestProcessId = await BPMService.postStartNewProcess(getters.processId, getters.processStartTaskId);
            fullData.data.mainData.requestProcessId = requestProcessId;
            fullData.data.mainData.createDateTime = moment().format();
            fullData.data.mainData.status = 'Черновик';
            await DocumentService.postDocuments(fullData);
            return true;
        } catch (e) {
            // TODO: отмена запущеного процесса
            console.log('request.saveRequest error: ' + e);
            return false;
        } finally {
        }
    },
    /**
     * Загружает данные документа-заявки
     * @param {*} requestId - ID документа
     */
    async loadRequest({ commit }, requestId) {
        try {
            commit('setRequestData', {});
            let document = await DocumentService.getDocumentById(requestId);
            commit('setRequestData', document.data);
            commit('setRequestFolderId', document.folderId);
        } catch (e) {
            console.log('request.loadRequest error: ' + e);
        }
    },
    /**
     * Обновляет данные документа
     */
    async updateRequest({ state }, { requestId, requestData, folderId }) {
        try {
            let fullData = { folderId: folderId == undefined ? state.requestFolderId : folderId, id: requestId, data: requestData };
            await DocumentService.postDocuments(fullData);
            return true;
        } catch (e) {
            console.log('request.updateRequest error: ' + e);
        }
    },
    /**
     * Загружает данные документа-заявки.
     * Готовит модель для выполнения шага процесса.
     * @param {*} processId
     * @param {*} requestId
     */
    async getRequestForView({ commit, dispatch }, documentId) {
        try {
            commit('setRequestLoading', true);
            commit('setRequestData', {});
            commit('setRequestSchema', []);
            let document = await DocumentService.getDocumentFormByDocumentId(documentId);
            commit('setRequestData', document.model.data);
            await Promise.all(
                document.schema.data.map(async item => {
                    let r = await SchemasService.getSchemaById(item.schemaId);
                    item.schema = await r.data.schema;
                })
            );
            // commit('setRequestSchema', document.schema.data);
            dispatch('parseSchemas', document.schema.data);
        } catch (e) {
            console.log(e);
        } finally {
            commit('setRequestLoading', false);
        }
    },
    async prepareExecuteTask({ commit, dispatch }, { processId, requestId }) {
        try {
            commit('setNeedSign', false);
            commit('setHideDraftBtn', false);
            let bpmActions = [];
            commit('setRequestLoading', true);
            dispatch('loadRequest', requestId);
            commit('setRequestSchema', []);
            let res = await BPMService.getSchemaByProcessId(processId);
            commit('setNeedSign', res.needSign);
            commit('setHideDraftBtn', !!res.hideDraftBtn);
            await Promise.all(
                res.schemas.map(async item => {
                    let r = await SchemasService.getSchemaById(item.schemaId);
                    item.schema = await r.data.schema;
                })
            );

            if (res[BPM_DECISION_PROPERTY_NAME].length) {
                res[BPM_DECISION_PROPERTY_NAME].forEach(value => {
                    bpmActions.push({ code: 'submitOK', title: value.text, color: 'primary', Type: 'submit', value: value.value, disabled: false });
                });
                bpmActions.push({
                    code: 'submitCancel',
                    title: 'Закрыть без сохранения',
                    color: '',
                    Type: 'reset',
                    disabled: false
                });
            }
            // commit('setRequestSchema', res.schemas);
            dispatch('parseSchemas', res.schemas);
            return bpmActions;
        } catch (e) {
            console.log('request.prepareExecuteTask error: ' + e);
        } finally {
            commit('setRequestLoading', false);
        }
    },
    async getDocumentPermissions({ commit }, documentId) {
        return await DocumentService.getUserDocumentPermissions(documentId);
    },
    async parseSchemas({ commit }, data){
        const requestSchemas = data.map(schema => parseFunctionsFromSchema(schema));

        commit('setRequestSchema', requestSchemas);
    },
    async getEdsInfo({ commit }, requestData) {
        return await DocumentService.getEdsInfo(requestData);
    },
    async deleteRequest({ commit }, requestId) {
        return await DocumentService.deleteDocument(requestId);
    }
};

// mutations
const mutations = {
    setSignInfo(state, data) {
        state.signInfo = data;
    },
    setNeedSign(state, data) {
        state.needSign = data;
    },
    setHideDraftBtn(state, data){
        state.hideDraftBtn = data;
    },
    setRequestList(state, data) {
        state.requestList = data;
    },
    setRequestLoading(state, data) {
        state.requestLoading = data;
    },
    setRequestFolderId(state, data) {
        state.requestFolderId = data;
    },
    setRequestData(state, data) {
        state.requestData = data;
    },
    setRequestSchema(state, data) {
        state.requestSchema = data;
    },
    setProcessData(state, data) {
        state.processData = data;
    }
};

export const request = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
